import {
  Middleware,
  configureStore as reduxConfigureStore,
} from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";
import createSagaMiddleware from "redux-saga";

import { setIsAPiRequestLoading } from "@app/modules/common";
import { persistRootReducer } from "./root-reducer";
import { rootSaga } from "./root-saga";

/* -----------[ configure store ]------------ */
export const loadingIncludes = [
  "/dashboard",
  "/nonParentCategories",
  "/usedCars",
  "/brand",
  "/findWheelers",
  "/findProductIdBy",
  "/myProfile",
  "/finedTestDrive",
  "/locationFindAll",
];
export const loadingExcludes = [
  "/dashboardSuccess",
  "/dashboardFailed",
  "/nonParentCategoriesSuccess",
  "/nonParentCategoriesFailed",
  "/usedCarsSuccess",
  "/usedCarsFailed",
  "/brandSuccess",
  "/brandFailed",
  "/findWheelersSuccess",
  "/findWheelersFailed",
  "/findProductIdBySuccess",
  "/findProductIdByFailed",
  "/myProfileSuccess",
  "/myProfileFailed",
  "/finedTestDriveSuccess",
  "/finedTestDriveFailed",
  "/locationFindAllSuccess",
  "/locationFindAllFailed",
];

export const loadingMiddleware: Middleware =
  (storeAPI) => (next) => (action: any) => {
    // You can customize which actions to track

    if (action.type === "common/setIsAPiRequestLoading") {
    } else {
      const match = loadingIncludes.some((path) => action.type.includes(path));
      const exclude = loadingExcludes.some((path) =>
        action.type.includes(path)
      );
      if (match && !exclude) {
        storeAPI.dispatch(setIsAPiRequestLoading(true));
      } else {
        storeAPI.dispatch(setIsAPiRequestLoading(false));
      }
    }
    return next(action);
  };

function configureStore() {
  const sagaMiddleware = createSagaMiddleware();

  // New middleware can be added here
  // const middleware = [sagaMiddleware];

  const store = reduxConfigureStore({
    reducer: persistRootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false })
        .concat(sagaMiddleware)
        .concat(loadingMiddleware),
    devTools: false,
  });

  const persistor = persistStore(store);

  // Run sagas
  rootSaga.forEach(sagaMiddleware.run);

  return { store, persistor };
}

export { configureStore };
